import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.show = $event),
    closeable: "",
    position: "bottom",
    style: {
      height: '40%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_van_form, {
      onSubmit: $options.buttonClick
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.form.validateCode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.validateCode = $event),
        clickable: "",
        required: "",
        name: "validateCode",
        label: "验证码：",
        placeholder: "验证码",
        rules: [{
          required: true,
          message: '请输入验证码'
        }]
      }, {
        button: _withCtx(() => [_createVNode(_component_van_image, {
          height: "24",
          width: "72",
          src: _ctx.codeCheckImg,
          disabled: _ctx.isCodeLoading,
          onClick: _cache[0] || (_cache[0] = $event => _ctx.onFreshCodeClickForAppointment({
            productId: this.productId,
            openDate: this.openDate
          }))
        }, null, 8, ["src", "disabled"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_button, {
        style: {
          "width": "100%"
        },
        type: "primary",
        size: "small",
        "native-type": "submit",
        loading: $data.btnLoading
      }, {
        default: _withCtx(() => [_createTextVNode(" 确定 ")]),
        _: 1
      }, 8, ["loading"])]),
      _: 1
    }, 8, ["onSubmit"])])]),
    _: 1
  }, 8, ["show"]);
}